import { render } from "./hoverEffect14.vue?vue&type=template&id=f85f4d86"
import script from "./hoverEffect14.vue?vue&type=script&lang=js"
export * from "./hoverEffect14.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__